module.exports = __webpack_public_path__ + "static/media/login_icon.b0ef3a73.png";